<template>
    <div id="unpack_workspace">
        <Pack v-for="pack in packs" :key="pack.identity" :pack="pack" :current_pack="current_pack" :all_packs="all_packs" />
    </div>
</template>

<script>
import Pack from "./workspace/pack.vue"
export default {
    props: {
        packs: Array,
        current_pack: Object,
        all_packs: Array,
    },
    data: function() {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
    },
    mounted: function() {
    },
    methods: {
    },
    components: {
        Pack
    }
}
</script>
